import { TimelineSegment } from "../vehicleCameraView/timeline/timeline";

export type DateKey = string; // e.g. "2026-01-21"

export interface RecordingDetails extends TimelineSegment{
}

export interface RecordingsForDate {
    recordings: RecordingDetails[];
}

export interface ChannelCache {
    [dateKey: DateKey]: RecordingsForDate;
}

export interface DeviceCache {
    [channelIdx: number]: ChannelCache;
}

export interface VehicleCache {
    [deviceId: string]: DeviceCache;
}

export type RecordingsCache = {
    [vehicleId: string]: VehicleCache;
};

export function upsertDayRecordingsToCache(
    cache: RecordingsCache,
    vehicleId: string,
    deviceId: string,
    channelIdx: number,
    dateKey: string,
    recordings: RecordingDetails[]
): RecordingsCache {
    return {
        ...cache,
        [vehicleId]: {
            ...cache[vehicleId],
            [deviceId]: {
                ...cache[vehicleId]?.[deviceId],
                [channelIdx]: {
                    ...cache[vehicleId]?.[deviceId]?.[channelIdx],
                    [dateKey]: { recordings }
                }
            }
        }
    };
}
export function getCachedRecordingsForDay(
    cache: RecordingsCache,
    vehicleId: string,
    deviceId: string,
    channelIdx: number,
    dateKey: string
): RecordingDetails[] | undefined {
    return cache[vehicleId]
        ?.[deviceId]
        ?.[channelIdx]
        ?.[dateKey]
        ?.recordings;
}